// Пара к инлайн-скрипту #early-clicks в index.html: кнопку, нажатую до запуска React, нажимаем снова

type EarlyClickWindow = Window & {
  __rpsoEarlyClick?: HTMLElement | null;
  __rpsoOnEarlyClick?: (event: Event) => void;
};

const earlyWindow = () => window as EarlyClickWindow; // as: поля задаёт инлайн-скрипт, в типах window их нет

let pending: HTMLElement | null = null;

/**
 * Перед hydrateRoot: дальше нажатия ловит сам React (он повторяет события, пришедшие во время
 * гидратации). Если продолжить запись, такое нажатие сработало бы дважды — меню открылось и закрылось
 */
export const stopEarlyClickCapture = (): void => {
  const w = earlyWindow();
  if (w.__rpsoOnEarlyClick) document.removeEventListener('click', w.__rpsoOnEarlyClick, true);
  pending = w.__rpsoEarlyClick ?? null;
  w.__rpsoEarlyClick = null;
  w.__rpsoOnEarlyClick = undefined;
};

/** После гидратации (эффект корня): нажатие, пришедшее раньше React, повторяем один раз */
export const replayEarlyClick = (): void => {
  const button = pending;
  pending = null;
  // Кнопка исчезла (страницу уже сменили) или отключена — нажимать нечего
  if (button?.isConnected && !button.hasAttribute('disabled')) button.click();
};
